import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getTheSupBranch, getDrugInformation, getCustInformation, insertOrderAutidDivId, insertOrderCustomer } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddCustomerModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    auditParams: Object
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const custKeyWord = ref('');
    const table = ref();
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        custKeyWord.value = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      pagerConfig: {
        pageSize: 10
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '客户ID',
        field: 'erpCustId',
        showOverflow: true
      }, {
        title: '客户名称',
        field: 'custName',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getCustInformation(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: props.supplierId,
              custKeyWord: custKeyWord.value
            }, props.auditParams), {}, {
              __warn: true
            })).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      emit('success', selectRows);
      visible.value = false; // insertOrderAutidDivId

      return;
      insertOrderCustomer(_objectSpread(_objectSpread({
        supplierId: props.supplierId,
        erpCustIds: selectRows.map(i => i.erpCustId).join(',')
      }, props.auditParams), {}, {
        __warn: true,
        __repeat: true
      })).then(data => {
        if (data.success) {
          emit('success');
          ElMessage.success('操作成功!');
          visible.value = false;
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "添加客户",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: custKeyWord.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => custKeyWord.value = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            style: {
              "margin-left": "10px"
            },
            onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};